import at from '../actionTypes'
import createReducer from './utilities/createReducer'
import entityTypes from '../../enums/entityTypes'
import weatherTypes from '../../enums/weatherTypes'
import temperatureTypes from '../../enums/temperatureTypes'
import Thing from '../../utilities/Data/Thing'
import maybe from '../../utilities/maybe'
import that from '../../utilities/translationHelper'
import showAppMessage from './utilities/showAppMessage'
import postKitConfig from '../../PostKitConfig'

export default createReducer({}, {
	[at.postSet_Success]: (state, action) => ({
		...state,
		postDraft: undefined, // remove the draft
		// optimistic post data
		post: {
			...action.payload.postDraft,
			postId: action.payload.postId
		}
	}),

	[at.postDraftKitFetch_Success]: (state, action) => {
		const postDraft = { ...state.postDraft, kit: action.payload.kit }
		//	Tag, as long as it hasn't already been tagged...
		postDraft.tags = [...postDraft.tags, ...maybe([Thing.getTag(action.payload.kit)], !postDraft.tags.find(tag => tag.kitId === action.payload.kit.kitId))]
		return {
			...state,
			postDraft
		}
	},

	[at.postDraftUserKitsFetch_Success]: (state, action) => ({
		...state,
		userProfileKits: action.payload.kits,
		postKitUserKitsHasMoreKits: (action.payload.limit ? action.payload.kits.length > postKitConfig.limit : false)
	}),

	[at.kudosPostUserFetch_Success]: (state, action) => ({
		...state,
		postKudosById: {
			...action.payload.kudos
		}
	}),

	[at.postHideFromFeedSet]: (state, action) => ({
		...state,
		post: {
			...state.post,
			hideFromFeed: !!action.payload.hideFromFeed
		}
	}),

	[at.postDraftAddTag]: (state, action) => {
		const newPostDraft = { ...state.postDraft || {} }

		newPostDraft.tags = newPostDraft.tags || []

		const newTag = { ...action.payload.tag }
		newPostDraft.tags.push(newTag)

		return {
			...state,
			postDraft: newPostDraft
		}
	},

	[at.postDraftRemoveTag]: (state, action) => {
		if (state.postDraft && state.postDraft.tags && state.postDraft.tags.length) {
			const thing = action.payload.thing
			const postDraft = state.postDraft
			const newPostDraft = { ...postDraft }

			const id = Thing.idObject(thing)
			const key = Object.keys(id)[0]
			newPostDraft.tags = postDraft.tags.filter(tag => tag[key] !== id[key])

			return {
				...state,
				postDraft: newPostDraft
			}
		}
		return state
	},

	[at.postDraftSetTags]: (state, action) => ({
		// this is only for x/y position setting, they should not get added or removed or re-ordered
		...state,
		postDraft: {
			...state.postDraft,
			tags: action.payload.tags
		}
	}),

	[at.postDraftSetImageUrl]: (state, action) => ({
		...state,
		postDraft: {
			...state.postDraft,
			images: undefined,
			imageUrl: action.payload.imageUrl
		}
	}),

	// TODO: ownwant - will change fetch following to be like own want

	[at.postFetchFollowing_Success]: (state, action) => ({
		...state,
		post: {
			...(state.post || {}),
			tags: [
				//	Add the following attribute, if we're following a user.
				...((state.post && state.post.tags) || []).map((tag) => {
					const newTag = { ...tag }
					if (tag.type === entityTypes.USER.type && (action.payload.followingIds && action.payload.followingIds.indexOf(tag.uid) !== -1)) {
						newTag.following = true
					}
					return newTag
				})
			]
		}
	}),

	[at.postDraftSet]: (state, action) => ({
		...state,
		postDraft: {
			...state.postDraft,
			...Object.keys(action.payload).reduce((acc, key) => {
				if (['location', 'timeTakenHours', 'timeTakenMinutes', 'dateTimestamp', ...(Object.keys(weatherTypes)), 'caption', 'temperatureType', 'lowTemperature', 'highTemperature'].indexOf(key) !== -1) {
					acc[key] = action.payload[key]
				}
				return acc
			}, {})
		}
	}),

	[at.postFetch]: state => ({
		...state,
		post: undefined
	}),

	[at.postFetch_Success]: (state, action) => ({
		...state,
		post: {
			...action.payload.post
		}
	}),

	[at.postFetch_Fail]: (state, action) => ({
		...state,
		...showAppMessage(that.context.translate('Post not found: {postId}', { postId: action.payload.postId }))
	}),

	[at.postDraftFetch]: state => ({
		...state,
		postDraft: undefined
	}),
	[at.postDraftFetch_Success]: (state, action) => ({
		...state,
		postDraft: {
			...action.payload.post
		}
	}),

	[at.postDraftCreate]: state => ({
		...state,
		postDraft: {
			dateTimestamp: new Date(),
			temperatureType: temperatureTypes.CELSIUS.type,
			...state.postDraft,
			//	Tag kit, as long as it hasn't already been tagged...
			tags: [
				...maybe(state.postDraft && state.postDraft.tags, state.postDraft),
				...maybe(state.kitDraft && [Thing.getTag(state.kitDraft)], !state.postDraft || (state.kitDraft && !state.postDraft.tags.find(tag => tag.kitId === state.kitDraft.kitId)))
			],
			kit: (state.postDraft && state.postDraft.kit) || state.kitDraft
		}
	}),
	[at.postDraftDelete]: state => ({
		...state,
		postDraft: undefined
	})
})



// WEBPACK FOOTER //
// ./src/redux/reducers/postReducer.js